// @flow
import { Toast } from 'primereact/toast'
import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { hideNotification } from '../redux/actions/notificationActions'

const Notification = () => {
  const { msg, type } = useSelector((state) => state.notification)
  const toast = useRef(null)
  const dispatch = useDispatch()

  useEffect(() => {
    if (msg.length > 0) {
      toast.current.show({
        severity: type,
        summary: msg,
        closable: true,
        life: 4000,
      })
    }
  }, [msg])

  return (
    <Toast
      ref={toast}
      position="bottom-right"
      style={{ width: '100%', right: 0 }}
      onHide={() => dispatch(hideNotification())}
    />
  )
}

export default Notification
